var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "winItem",
      on: {
        click: function ($event) {
          return _vm.lookDetails(_vm.item.courseLink)
        },
      },
    },
    [
      _c("div", { staticClass: "itembox" }, [
        _c("div", { staticClass: "title" }, [
          _c("div", [_vm._v(_vm._s(_vm.item.courseName))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "line" }),
        _vm._v(" "),
        _c("div", { staticClass: "school" }, [
          _vm._v(_vm._s(_vm.item.fkCourseEmceeSchool)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tips" }, [
          _vm.item.hostTeacher
            ? _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.item.hostTeacher)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.year
            ? _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.item.year)),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }